angular.module('rjmNg.directives').directive "sqlSidebar", [
  () ->
    restrict: "E"
    templateUrl: "directive.sqlSidebar.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope: {}
    controller: [
      "$rootScope"
      "app"
      "Metrics"
      "notification"
      "Columns"
      "Tables"
      "errorConstants"
      "metricEnums"
      "FEATURE_TIER"
      (
        $rootScope
        app
        Metrics
        notification
        Columns
        Tables
        errorConstants
        metricEnums
        FEATURE_TIER
      ) ->

        view = @
        view.loading = true

        view.metrics = []
        view.columns = []
        view.searchName = ""
        view.displayMiniInfo = false
        view.databases = []
        view.tables = []
        view.selectedMetric = null
        view.selectedTable = {}
        view.showTables = true
        view.allowViewSwitch = !app.hasFeatureFlag('RJQL_SERVICE_CLIENT')

        UNSUPPORTED_AGGREGATES = [
          metricEnums.AGGREGATE_FUNCTIONS.MEDIAN
          metricEnums.AGGREGATE_FUNCTIONS.FIRST_QUARTILE
          metricEnums.AGGREGATE_FUNCTIONS.THIRD_QUARTILE
          metricEnums.AGGREGATE_FUNCTIONS.TENTH_PERCENTILE
          metricEnums.AGGREGATE_FUNCTIONS.NINETIETH_PERCENTILE
        ]

        getMetrics = ->
          Metrics.get(app.getClientId())
          .then (metrics) ->
            view.metrics = metrics.map (metric) ->
              metric.prettyCommand = metricEnums.AGGREGATE_FUNCTIONS[metric.command]
              if metricEnums.AGGREGATE_FUNCTIONS[metric.command] in UNSUPPORTED_AGGREGATES
                metric.unsupported_error = metric.prettyCommand + ' metrics are not presently supported.'
                metric.supported = false
              else if metric.subscription_column_id isnt null
                metric.unsupported_error = "Subscription metrics are not presently supported."
                metric.supported = false
              else
                metric.supported = true
              metric
            view.loading = false
          .catch (error) ->
            view.loading = false
            notification.error("Server Error",
              errorConstants.SERVER_ERROR_MESSAGE,
              "metrics",
              null
            )

        getConnectionsAndTables = ->
          Tables.getCollection().then( (tables) ->

            # add the database name to the array so that we can use it in a filter
            angular.forEach(tables, (table) ->
              view.tables.push(table)
              if table.type is "consolidated"
                table.database = "Consolidated Tables"
              else if table.type is "view"
                table.database = "Data Warehouse Views"
              else if table.remote_table
                table.database = table.remote_table.database
            )

            view.tables = tables
            view.databases = Tables.getDatabases(tables)
          )

        view.inDatabase = (database) ->
          (table) ->
            return table.database? and
              table.database is database.name

        view.showColumns = (tableId, tableName) ->
          view.selectedTable =
            id: tableId
            name: tableName
          view.columns = []
          Columns.getCollection().then( (columns) ->
            angular.forEach(columns, (column) ->
              if column.table_id is tableId
                if !app.hasFeatureFlag('RJQL_SERVICE_CLIENT') or column.type isnt 'derivative' # dont show derivatives for BASIC tier clients
                  view.columns.push(column)
            )
          )

        view.showMetricInfo = (metric) ->
          view.selectedMetric = metric
          $rootScope.$broadcast('expandMetricDetails', metric.id)

        view.openExpander = (database) ->
          database.expanded = !database.expanded

        view.insertMetricIntoQuery = (metric) ->
          Metrics.get(app.getClientId(), metric.id)
          .then( (metric) ->
            sql = "#{metric.sql} LIMIT 3500"
            insertText(sql)
          )

        view.insertColumnIntoQuery = (column) ->
          textToDisplay = "\"#{column.warehouse_name}\""
          insertText(textToDisplay)

        view.insertTableIntoQuery = (table) ->
          textToDisplay = "\"#{table.warehouse_name}\""
          insertText(textToDisplay)

        insertText = (text) ->
          $rootScope.$broadcast('insertTextIntoSQLQuery', text)

        init = ->
          getMetrics()
          getConnectionsAndTables()

        init()
        return view

    ]
]
